import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import { isBrowser } from 'ws-scripts/modules/environment';
import { setClassNames } from '@ddc/classnames-js';
import VehicleToolbar from './VehicleToolbar';
import '../global-sass/variables.scss';
import { filterPrimaryCTA } from '../utils';
import { useStickyVehicleToolbar } from '../hooks';

const Widget = () => {
	const pubsub = isBrowser && window?.DDC?.pubsub;
	const [isModalOpen, setIsModalOpen] = useState(false);
	const [vehiclePrice, setVehiclePrice] = useState('');
	const [vehicleTitle, setVehicleTitle] = useState([]);
	const [vehiclePayment, setVehiclePayment] = useState();
	const [vehicleCTAs, setVehicleCTAs] = useState([]);
	const [isBlackBackgroundModal, setIsBlackBackgroundModal] = useState(false);

	useStickyVehicleToolbar();

	// These pubsub events are saved into local state and used to access the data when the toolbar gets portaled into ws-vehicle-gallery
	useEffect(() => {
		if (pubsub) {
			pubsub.subscribe('ws-vehicle-toolbar/show-price', (price) => {
				setVehiclePrice(price);
			});
			pubsub.subscribe(
				'ws-vehicle-toolbar/show-vehicle-title',
				(titleArr) => {
					setVehicleTitle(titleArr);
				}
			);
			pubsub.subscribe(
				'ws-vehicle-toolbar/show-vehicle-ctas',
				(ctasData) => {
					const primaryCTA = filterPrimaryCTA(ctasData);
					setVehicleCTAs(primaryCTA);
				}
			);
			pubsub.subscribe(
				'ws-vehicle-toolbar/show-vehicle-payment',
				(paymentData) => {
					setVehiclePayment(paymentData.payment);
				}
			);
			pubsub.subscribe('ws-vehicle-gallery/modal-open', (isOpen) => {
				setIsModalOpen(isOpen);
			});
			pubsub.subscribe(
				'ws-vehicle-toolbar/set-black-background',
				(isBlackBackground) => {
					setIsBlackBackgroundModal(isBlackBackground);
				}
			);
		}
		return () => {
			pubsub.unsubscribe('ws-vehicle-toolbar/show-price');
			pubsub.unsubscribe('ws-vehicle-toolbar/show-vehicle-title');
			pubsub.unsubscribe('ws-vehicle-toolbar/show-vehicle-ctas');
			pubsub.unsubscribe('ws-vehicle-toolbar/show-vehicle-payment');
			pubsub.unsubscribe('ws-vehicle-gallery/modal-open');
			pubsub.unsubscribe('ws-vehicle-toolbar/set-black-background');
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [pubsub]);

	const vehicleGalleryToolbarContainer =
		typeof document !== 'undefined' && isModalOpen
			? document.querySelector('.vehicle-gallery-toolbar-react-portal')
			: null;

	const galleryCTAs = isBlackBackgroundModal
		? vehicleCTAs.map((cta) => ({
				...cta,
				btnClasses: setClassNames([
					...cta.btnClasses.split(' '),
					'btn-inverse'
				])
		  }))
		: vehicleCTAs;

	return (
		<>
			<VehicleToolbar
				vehiclePrice={vehiclePrice}
				vehicleTitle={vehicleTitle}
				vehiclePayment={vehiclePayment}
				vehicleCTAs={vehicleCTAs}
			/>
			{vehicleGalleryToolbarContainer &&
				ReactDOM.createPortal(
					<VehicleToolbar
						isVehicleGallery
						vehiclePrice={vehiclePrice}
						vehicleTitle={vehicleTitle}
						vehiclePayment={vehiclePayment}
						vehicleCTAs={galleryCTAs}
					/>,
					vehicleGalleryToolbarContainer
				)}
		</>
	);
};

export default Widget;
